import { Suspense, lazy, useEffect, useState } from "react";
import { useScroll } from "framer-motion";
import Hero from "@/components/Hero";
import RecentlyFunded from "@/components/RecentlyFunded";
import Trust from "@/components/Trust";
import Process from "@/components/Process";
import FinalCTA from "@/components/FinalCTA";
import JourneyRail from "@/components/JourneyRail";

const Experience = lazy(() => import("@/components/three/Experience"));

// The signature cinematic homepage: dream (hero) -> the journey (process)
// -> home (final CTA with the key). Deep content lives on dedicated pages.
export default function HomePage({ onLead }) {
  const [show3D, setShow3D] = useState(false);
  const [lite3D, setLite3D] = useState(false);
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    document.title = "My First Home Mortgage Ltd — Private Mortgage Advisory · Akashdeep Ghai";
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const mobile = window.matchMedia("(max-width: 1023px)").matches;
    setShow3D(!reduced);
    setLite3D(mobile);
  }, []);

  return (
    <>
      {show3D && (
        <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
          <Suspense fallback={null}>
            <Experience progress={scrollYProgress} lite={lite3D} />
          </Suspense>
        </div>
      )}
      <JourneyRail />
      <div className="relative z-10">
        <main>
          <Hero onLead={onLead} show3D={show3D} />
          <RecentlyFunded />
          <Trust />
          <Process onLead={onLead} />
          <FinalCTA onLead={onLead} show3D={show3D} />
        </main>
      </div>
    </>
  );
}
